import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import CAxios from "../utils/CAxios";
import axios, { AxiosResponse } from "axios";

export const toGetBrands = createAsyncThunk<AxiosResponse<any, any>, any>(
  "vehicle/brands",
  async (lang) => {
    try {
      const response = await axios.get(`${baseUrlApi}brands?lang=${lang}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const toGetModel = createAsyncThunk("vehicle/models", async () => {
  try {
    const response = await axios.get(`${baseUrlApi}models`);
    return response;
  } catch (error) {
    throw error;
  }
});

export const togetCategories = createAsyncThunk(
  "vehicle/categories",
  async ({ type, lang }: { type: "service" | "other"; lang: string }) => {
    try {
      const response = await CAxios.post(
        `categories?lang=${lang}`,
        {
          category_type: type,
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const toGetProductCategories = createAsyncThunk<
  AxiosResponse<any, any>,
  string
>("vehicle/productCategories", async (lang) => {
  return axios.get(`${baseUrlApi}categories?lang=${lang}`);
});

export const toGetServiceCategoriesTree = createAsyncThunk<
  AxiosResponse<any, any>,
  { lang?: string }
>(
  "vehicle/serviceCategoriesTree",
  async () => {
    return CAxios.get(`categories/tree`, {
      params: {
        category_type: "service",
      },
    });
  },
  {
    condition: (_arg, { getState }) => {
      const state = getState() as {
        vehicle?: { serviceCategoryTree?: { status?: string } };
      };
      return state.vehicle?.serviceCategoryTree?.status !== "loading";
    },
  }
);

export const toGetProductCategoriesTree = createAsyncThunk<
  AxiosResponse<any, any>,
  { lang?: string }
>(
  "vehicle/productCategoriesTree",
  async ({ lang }) => {
    return CAxios.get(`categories/tree`, {
      params: {
        category_type: "other",
        ...(lang ? { lang } : {}),
      },
    });
  },
  {
    condition: (_arg, { getState }) => {
      const state = getState() as {
        vehicle?: { productCategoryTree?: { status?: string } };
      };
      return state.vehicle?.productCategoryTree?.status !== "loading";
    },
  }
);

export const toAddVehicle = createAsyncThunk(
  "vehicle/add",
  async (data: any) => {
    try {
      const response = await CAxios.post(`vehicles`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const toGetMyVehicle = createAsyncThunk<AxiosResponse<any, any>, string>(
  "vehicle/my",
  async (lang) => {
    try {
      const response = await CAxios.get(
        `my/vehicles?lang=${lang}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const ToEditCar = createAsyncThunk(
  "profil/toEditCar",
  async (data: any) => {
    try {
      const response = await CAxios.post(`vehicles/edit`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
